import loadable from '../../utilities/loadable'

export const BuyNowRoot = loadable(() => import('./BuyNowRoot'))
export const MakeOffer = loadable(() => import('./MakeOffer'))
